import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "7",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#347E96",
  d: "M.12 5.71 5.71.12a.41.41 0 0 1 .698.29V6a.41.41 0 0 1-.41.409H.41a.41.41 0 0 1-.29-.699Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#245869",
  d: "m.12 6.29 5.59 5.59a.41.41 0 0 0 .698-.29V5.592H.41a.41.41 0 0 0-.29.699Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }